import React, { useState, useEffect } from 'react';
import { useAppointmentsPG } from '../../hooks/useAppointmentsPG';
import YearOverYearChart from './YearOverYearChart';
import { useTranslations } from '../../hooks/useTranslations';

const AppointmentsMonthComparison = () => {
  const { getMonthlyAppointmentsSummary, loading, error } = useAppointmentsPG();
  const [chartData, setChartData] = useState([]);
  const [chartLoading, setChartLoading] = useState(false);
  const [chartError, setChartError] = useState(null);

  const t = useTranslations()
  
  // Load chart data function
  const loadChartData = async () => {
    try {
      setChartLoading(true);
      setChartError(null);
      
      console.log('Dashboard: Loading monthly appointments data for comparison chart');
      const data = await getMonthlyAppointmentsSummary();
      
      console.log('Dashboard: Successfully loaded data', {
        monthsCount: data.length,
        dateRange: data.length > 0 ? 
          `${data[0].date} to ${data[data.length - 1].date}` : 
          'No data'
      });
      
      setChartData(data);
    } catch (error) {
      console.error('Dashboard: Failed to load chart data:', error);
      setChartError(error.message);
    } finally {
      setChartLoading(false);
    }
  };

  useEffect(() => {
    loadChartData();
  }, [getMonthlyAppointmentsSummary]);

  // Refresh function for manual reload
  const handleRefresh = async () => {
    console.log('Dashboard: Manual refresh triggered');
    await loadChartData();
  };

  if (chartLoading) {
    return (
      <div className="p-6">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">{t.charts.dashboard.loadingAppointmentData}</p>
          </div>
        </div>
      </div>
    );
  }

  if (chartError || error) {
    return (
      <div className="p-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-red-800 font-medium">{t.charts.dashboard.errorLoadingData}</h3>
              <p className="text-red-600 text-sm mt-1">
                {chartError || error}
              </p>
            </div>
            <button
              onClick={handleRefresh}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      {/* Year-over-Year Chart */}
      <YearOverYearChart data={chartData} />
    </div>
  );
};

export default AppointmentsMonthComparison;